export class LeaSearchParams {
  onlyCOEs: string = 'all';
  restrictActive: string = 'true';
  fiscalYearId: number = 0;
  coeId: number = 0;
  showQualifiedHistory: boolean = false;
}

